/** Account isolation shared by intelligence features; no Context runtime dependency. */
export async function verifyOwner(meta: { get: (key: string) => Promise<{ value: unknown } | undefined> }, owner: string) {
  const bound = (await meta.get('sync-owner'))?.value
  if (!owner || (typeof bound === 'string' && bound !== owner)) throw new Error('Account changed. Reopen this action in the current account.')
}
